import { getUserInitialLastName } from '@schooly/utils/user-helpers';
import { EntryCreator } from 'libs/api/src/lib/generated/schooly-api-v2';
import { useIntl } from 'react-intl';

import { DEFAULT_DATE_FORMAT_FNS, FilterKeys, MAX_PAGE_SIZE, SORT_DIRECTION } from '@schooly/api';
import { format } from 'date-fns';

export const useCreatorLabel = (creator: EntryCreator, relationId: string) => {
  const { formatMessage } = useIntl();
  const isMe = creator.relation_id === relationId;
  return isMe
    ? formatMessage({ id: 'dashboard-teacher-CreatedByYou' })
    : formatMessage(
        { id: 'dashboard-teacher-CreatedBy' },
        {
          name: getUserInitialLastName({
            ...creator,
            last_name: creator.last_name ?? '',
          }),
        },
      );
};

export const buildStaffGroupsQueryParams = ({
  schoolId,
  relationId,
}: {
  schoolId: string;
  relationId: string;
}) => ({
  schoolId,
  pageSize: MAX_PAGE_SIZE,
  sort: { columnTextId: 'name' as const, direction: SORT_DIRECTION.ASC },
  min: true,
  filters: {
    [FilterKeys.SingleDate]: [format(new Date(), DEFAULT_DATE_FORMAT_FNS)],
    [FilterKeys.Staff]: [relationId],
  },
});
